import { useEffect, useState } from "react";
import { GetRole } from "../api/roles/getRole";

// Legacy office-scoped role names; used only when the role's permission
// bundle cannot be fetched (keeps the pre-dynamic behavior as fallback).
const LEGACY_OFFICE_ROLES = ["agent", "office_admin"];

// A role's office shape is data-driven, not name-driven. Roles granted
// `all_offices.read` see every office's rows; roles without it are scoped to
// the user's assigned offices, so the office picker must be shown and
// assignments submitted.
const useRoleOfficeShape = (roleId, roleName) => {
  const [officeScoped, setOfficeScoped] = useState(false);

  useEffect(() => {
    if (!roleId) {
      setOfficeScoped(false);
      return undefined;
    }

    // Legacy roles are identified by name (e.g. "admin"), not a numeric id.
    // They have no dynamic permission bundle to fetch (GetRole would 400), so
    // derive the office shape from the static list instead.
    if (!/^\d+$/.test(String(roleId))) {
      setOfficeScoped(LEGACY_OFFICE_ROLES.includes(roleName || String(roleId)));
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const detail = await GetRole(roleId);
        const permissions = detail?.permissions;
        if (!cancelled && permissions && typeof permissions === "object") {
          setOfficeScoped(permissions.all_offices?.read !== true);
          return;
        }
      } catch (err) {
        console.log("Error fetching role permissions: " + err);
      }
      if (!cancelled) setOfficeScoped(LEGACY_OFFICE_ROLES.includes(roleName));
    };
    load();

    return () => {
      cancelled = true;
    };
  }, [roleId, roleName]);

  return officeScoped;
};

export default useRoleOfficeShape;
